module.exports = __webpack_public_path__ + "static/media/cover.a52cd5ed.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/cover.JPG
// module id = 808
// module chunks = 0